jQuery(document).ready(function($){
  $(".template-product a.scroll-review").click(function() {
    $('html, body').animate({
      scrollTop: $("#shopify-product-reviews--wrapper").offset().top
    }, 2500);
  });
});

// FAQ Accordian Tab

jQuery(document).ready(function($){

  $(".cms-static-page-view .accordion-section-title").click(function(){
    $(this).next(".cms-static-page-view .accordion-section-content").slideToggle("slow")
    .siblings(".cms-static-page-view .accordion-section-content:visible").slideUp("slow");
    $(this).toggleClass("active");
    $(this).siblings(".cms-static-page-view .accordion-section-title").removeClass("active");
  });
});

// Mobile Menu 

if ($(window).width() < 900) {

  $('.sidenav a svg').on("click", function (e) {
    $(this).parent('.site-nav__link--button').next('.site-nav__dropdown').slideToggle(600);
    $(this).toggleClass('ion-ios-arrow-down ion-ios-arrow-up');
    e.stopPropagation();
    e.preventDefault();
  });
}

// announcement bar slider

$('.owl-carousel-slide').owlCarousel({

  responsive:true,
  loop:true,
  autoplay: true,
  items:2,
  dots:false,
  responsive:{
    0:{
      items:1
      // nav:true,
      // dots:false
    },
    1500:{
      items:1,
      nav:false,
      //             dots:false
      // loop:true
    }
  }
});
